export default __webpack_public_path__ + "static/media/zumzi_agent_servicii.9e6eb7be.png";